import React from 'react';
import styled from 'styled-components';

import { WeeksDto } from '@/application/interfaces/pegasus.gateway';

import CourseSlider from '../course-slider';

type Props = {
  week: WeeksDto;
  totalLessons: number;
};

const Container = styled.header`
  margin-bottom: 1em;
`;

const HeaderContainer = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--neutral-color-600);
  margin-bottom: 24px;
  padding-bottom: 8px;
`;

const Title = styled.h1`
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -1px;
  text-align: left;
`;
const MoreInfo = styled.p`
  color: #caccce;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
`;

const ShowChildClassifierNameAndAmount: React.FC<{ week: WeeksDto }> = ({ week }) => {
  const weekLength = week.planned.length;
  const name = weekLength > 1 ? 'cursos' : 'curso';

  return (
    <MoreInfo>
      {weekLength} {name.toLocaleLowerCase()}
    </MoreInfo>
  );
};

const Classifier: React.FC<Props> = ({ week }) => {
  return (
    <Container>
      <HeaderContainer>
        <Title>Semana {week.order}</Title>
        <ShowChildClassifierNameAndAmount week={week} />
      </HeaderContainer>

      <CourseSlider courses={week.planned} weekOrder={week.order} />
    </Container>
  );
};

const ClassifierItem: React.FC<Props> = ({ week, totalLessons }) => {
  return <Classifier totalLessons={totalLessons} week={week} />;
};

export default ClassifierItem;
